import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { Alert, AlertTitle } from "@material-ui/lab";
import { kmMessages, getSystemLabel } from "src/constant/Messages";
import { apiEndpoints, apiPostRequest } from "src/utils/api/api";
import { useParams } from "react-router";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "42%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "52%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const PassActivationView = ({
  globalData,
  setAuthorized,
  setCurrentUserData,
  enableGlobalLoader,
  disableGlobalLoader,
}) => {
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const { activationKey } = useParams();
  const [successResult, setSuccessResult] = useState(false);

  useEffect(() => {
    enableGlobalLoader();

    apiPostRequest(
      apiEndpoints.passwordActivation.path,
      { activationToken: activationKey },
      false
    )
      .then((data) => {
        setSuccessResult(true);
        disableGlobalLoader();
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.status === 400 &&
          error.response.data
        ) {
          if (error.response.data.code === "ERROR_TOKEN_NOT_FOUND") {
            setErrorMessage(kmMessages.error.password_reset.linkexpired);
          } else {
            setErrorMessage(kmMessages.error.password_reset.apierror);
          }
        } else {
          setErrorMessage(kmMessages.error.password_reset.apierror);
        }
        disableGlobalLoader();
      });
    return () => {};
  }, []);

  useEffect(() => {
    if (successResult) {
      setInfoMessage(
        getSystemLabel("programPassActivationSuccess", globalData.systemInfo)
      );
    }
    return () => {};
  }, [globalData.systemInfo.fundProgram, successResult]);

  return (
    <Page className={classes.root} title="Aktywacja hasła tymczasowego">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          {infoMessage || errorMessage ? (
            <Box mb={1}>
              <Typography color="textPrimary" variant="h2">
                Aktywacja hasła
              </Typography>
              {errorMessage.length > 0 ? (
                <Alert severity="error" className={classes.massagebox}>
                  {errorMessage}
                </Alert>
              ) : (
                <></>
              )}
              {infoMessage ? (
                <Alert severity="success" className={classes.massagebox}>
                  <div>{infoMessage}</div>
                </Alert>
              ) : (
                <></>
              )}
              <Box my={2}>
                <Button
                  component={RouterLink}
                  to="/logowanie"
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Strona logowania
                </Button>
              </Box>
            </Box>
          ) : (
            <></>
          )}
        </Container>
        <Box display="flex" alignItems="flex-end" flexGrow={1} p={1}>
          <Box display="flex" flexDirection="column">
            <img
              className={classes.img}
              alt="Logo UE stopka"
              src="/static/images/logo_ue_main.jpg"
            />
            <Typography
              variant="caption"
              gutterBottom
              color="textSecondary"
              align="center"
              component="p"
            >
              Aplikacja współfinansowana przez Unię Europejską ze środków
              Europejskiego Funduszu Społecznego w ramach Regionalnego Programu
              Operacyjnego Województwa Podlaskiego na lata 2014-2020
            </Typography>
            <Typography
              color="textPrimary"
              variant="subtitle2"
              align="center"
              component="p"
            >
              2021 © Urząd Marszałkowski Województwa Podlaskiego
            </Typography>
          </Box>
        </Box>
      </Box>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  setAuthorized: (isAuthorized) =>
    dispatch(actions.setAuthorized(isAuthorized)),
  setCurrentUserData: (currentUserData) =>
    dispatch(actions.setCurrentUser(currentUserData)),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PassActivationView);
